import { render, staticRenderFns } from "./ProductionUnitWizard.vue?vue&type=template&id=37811834&scoped=true"
import script from "./ProductionUnitWizard.vue?vue&type=script&lang=js"
export * from "./ProductionUnitWizard.vue?vue&type=script&lang=js"
import style0 from "./ProductionUnitWizard.vue?vue&type=style&index=0&id=37811834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37811834",
  null
  
)

export default component.exports